import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchTinyurlData, createTinyurl } from "../../features/tinyurl/tinyurlSlice";
import { ToastContainer, toast } from "react-toastify";
import { formatDate } from "../../utils/dateUtils";
import { Button, OverlayTrigger, Tooltip, Modal, Form } from "react-bootstrap";
import TinyurlModal from "../common/TinyurlModal";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import Breadcrumbs from './../../Breadcrumbs';



const UpcomingVideo = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const decodeToken = useDecodedToken();

    const { tinyurlData, createTinyurls, status, message } = useSelector(
        (state) => state.tinyUrl
    );

    const [showEditModal, setShowEditModal] = useState(false);
    const [videosDataDetails, setVideoDataDetails] = useState("");

    const [showUtmModal, setShowUtmModal] = useState(false);


    useEffect(() => {
        dispatch(fetchTinyurlData());
    }, [dispatch]);

 
    useEffect(() => {
        console.log("tinyurlData ==>", tinyurlData);
    }, [tinyurlData]);


  return (
    <>
      <ToastContainer />
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">
              Tiny URL List
            </h4>
            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="leadsList">
              <div className="card-header border-0">
                <div className="row g-4 align-items-center">
                  <div className="col-sm-auto ms-auto">
                    <div className="hstack gap-2">
                        <Button
                            size="sm"
                            variant="success"
                            onClick={() => setShowUtmModal(true)}
                            >
                            + Create Tiny URL
                        </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    id="scroll-horizontal"
                    className="table table-bordered nowrap table-striped align-middle"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>SR No.</th>
                        <th>Action</th>
                        <th>Tiny URL</th>
                        <th>Main URL</th>
                        <th>Created At</th> 
                      </tr>
                    </thead>
                    <tbody>
                        {tinyurlData?.data && tinyurlData.data.length > 0 ? (
                            tinyurlData.data.map((video, index) => {
                                return (
                                    <tr key={video.id}>
                                        <td>{index + 1}</td>
                                        <td>{video.tinyurl_id}</td>
                                        <td>{video.tiny_url}</td>
                                        <td>{video.main_url}</td>
                                        <td>
                                            {video.created_at
                                            ? formatDate(video.created_at)
                                            : "-"}
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="12" className="text-center">
                                    No Videos Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <TinyurlModal
            showUtmModal={showUtmModal}
            setShowUtmModal={setShowUtmModal}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default UpcomingVideo;
